import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

const namespace = 'widgets';
export const keyPrefix = 'departmentListList';
export const useDepartmentListListTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};
export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Списки',
    mode_ownership: 'Владение',
    mode_view: 'Просмотр',
    actions: 'Действия',
  },
}) : {}) as Record<string, unknown>;
export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Lists',
    mode_ownership: 'Ownership',
    mode_view: 'View',
    actions: 'Actions',
  },
}) : {}) as Record<string, unknown>;
export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Listas',
    mode_ownership: 'Propiedad',
    mode_view: 'Vista',
    actions: 'Acciones',
  },
}) : {}) as Record<string, unknown>;
export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Listas',
    mode_ownership: 'Propriedade',
    mode_view: 'Visualizar',
    actions: 'Ações',
  },
}) : {}) as Record<string, unknown>;
